module.exports = __webpack_public_path__ + "img/Entrance.3546671e.png";